export default "__VITE_ASSET__CjKJkHRJ__";